"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/ function(TestId) {
    TestId["AvailablePoints"] = "available-points";
    TestId["Description"] = "description";
    TestId["ExpiringPoints"] = "expiring-points";
    TestId["Message"] = "message";
    TestId["Offer"] = "offer";
    TestId["OfferCarousel"] = "offer-carousel";
    TestId["OfferList"] = "offer-list";
    TestId["OfferListSkeleton"] = "offer-list-skeleton";
    TestId["OfferNoProductsFound"] = "offer-no-products-found";
    TestId["OfferLoading"] = "offer-loading";
    TestId["OfferSkeleton"] = "offer-skeleton";
    TestId["OfferStepSkeleton"] = "offer-step-skeleton";
    TestId["SingleOffer"] = "single-offer";
    TestId["Title"] = "title";
    TestId["Validity"] = "validity";
    return TestId;
}({});
